<template>
   
  <div class="login-container clearfloat" :style="note">
    <!-- <span style="position:absolute;color:white;bottom:0px;left:0px;width:110px;">
             Version 240119
    </span> -->
    <el-row v-show="this.$util.defLanguage=='zh'">
    <span style="margin-top:10px;margin-right:10px;float:right;width:100px;">
      <el-image
        :src="require('@/assets/appTwoCode.png')"
        z-index:9999
        lazy:true
        fit:cover
        style="width:100px;height:100px;cursor:pointer">
      </el-image>
      <span style="width:100px;color:white;display:flex;justify-content:center;">{{$t('login.app-txt')}}</span>
    </span>  
    </el-row>
    <el-row v-show="this.$util.defLanguage=='en'">
    <span style="margin-top:10px;margin-right:10px;float:right;width:100px;">
      <el-image
        :src="require('@/assets/hwAndroid.png')"
        z-index:9999
        lazy:true
        fit:cover
        style="width:100px;height:100px;cursor:pointer">
      </el-image>
      <span style="width:100px;color:white;display:flex;justify-content:center;">{{$t('login.hw-app-txt')}}</span>
    </span>
    </el-row>
    <el-form
      :model="ruleForm2"
      :rules="rules2"
      status-icon
      ref="ruleForm2"
      label-position="left"
      label-width="0px"
      class="demo-ruleForm login-page"
    >
      <el-form-item> 
          <span class="title" style="color:white;font-size:24px">{{$t('login.title')}}</span>
      </el-form-item>
      <el-form-item prop="username">
        <el-row>
          <el-col :span="14">
            <el-radio-group v-model="loginType">
              <el-radio-button :label="1" value="1">{{$t('login.mobile')}}</el-radio-button>
              <el-radio-button :label="0" value="0">{{$t('login.mailbox')}}</el-radio-button>
            </el-radio-group>
          </el-col>
          <el-col :span="10">
            <el-row style="line-height:20px;text-align:right" v-show="this.$util.defLanguage=='en'">
                <el-link @click="register" type="primary">{{$t('login.register')}}</el-link>
            </el-row>  
            <el-row style="line-height:20px;text-align:right">
                <el-link @click="passwordForget" type="warning">{{$t('login.forgetPassword')}}</el-link>
            </el-row> 
           
          </el-col>

        </el-row>
        <el-row style="margin-top:15px">
          <el-input
            type="phone"
            v-model="ruleForm2.username"
            :placeholder="$t('login.username')"
            auto-complete="off"
            @keyup.enter.native="handleSubmit()"
          ></el-input>
        </el-row>
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          type="password"
          v-model="ruleForm2.password"
          :placeholder="$t('login.password')"
          auto-complete="off"
          @keyup.enter.native="handleSubmit()"
        ></el-input>
      </el-form-item>
      <el-form-item style="width:100%;color:white">
        <el-col :span="14">
          <!-- <el-checkbox v-model="checked" class="rememberme">{{$t('login.remember')}}</el-checkbox> -->
          <country @showCountry="updateCountry" :sendData="toCountry"></country>
        </el-col>
        <el-col :span="10">
          <el-select v-model="languageType" @change="languagesChange">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-col>
      </el-form-item>

      <el-form-item style="width:100%;">
        <el-button
          type="primary"
          style="width:100%;"
          @click="handleSubmit"
          :loading="logining"
        >{{$t('login.loginbtn')}}</el-button>
      </el-form-item>
       <el-row style="display:flex;justify-content:center;margin-top:-10px">
        <span style="color:white;">
            Version 240306
        </span>
    </el-row>  
    </el-form>
    <span style="width:100%;position:absolute;color:white;bottom:15px;display:flex;justify-content:center;">
             <span>Copyright©2020 {{$t('login.companyName')}} <span @click="onBeian" id='beian' style="margin-left:5px">粤ICP备 08009650号-5</span></span>
    </span>
  </div>
</template>

<script>
import country from "./country.vue";
export default {
  //官方推荐select国际化加载数据须在computed
  computed: {
    options() {
      if(this.$util.defLanguage=='en'){
        return [
         { value: "1", label: this.$t("login.en") },
         { value: "0", label: this.$t("login.zh") }
        ]; 
      }else{
        return [
         { value: "0", label: this.$t("login.zh") },
         { value: "1", label: this.$t("login.en") }
        ]; 
      }
     
    },
    rules2(){
      var validateUserName = (rule, value, callback) => {
      if (this.loginType == 1) {
        var boolean = new RegExp('^[1-9][0-9]*$').test(value)
        if (!boolean) {
          var mobileFormatError=this.$t("login.mobile-msg-error");
          callback(new Error(mobileFormatError));
        }else{
          callback();
        }
      } else {
        // var mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
        // if (!mailReg.test(value)) {
        //   var emailFormatError=this.$t("login.email-msg-error");
        //   callback(new Error(emailFormatError));
        // }else{
        //   callback();
        // }
        if(value.indexOf("@")!=-1){
          callback();
        }else{
           callback(new Error(this.$t("register.email-msg-error")));
        }
      }
      };
      const rules={
        username: [
          {required: true,message: this.$t("login.accout-null"),trigger: "blur"},
          // { min: 4, max: 18, message: this.$t("login.account-msg"), trigger: 'blur' },
          { validator: validateUserName, trigger: "blur" }
        ],
        password: [
          { required: true, message: this.$t("login.password-null"), trigger: "blur" }
        ]
      }
      return  rules;
    }
  },
  created(){
      var languageType=localStorage.getItem("language");
      //加载前默认当前本地记忆的语言
      switch(languageType){
        case "zh":
           this.languageType="0"
           this.$store.state.languageType="0";
          break;
        case "en":
           this.languageType="1";
           this.$store.state.languageType="1";
          break;
        default:
          if(this.$util.defLanguage=='zh'){
            this.languageType="0";
            this.$store.state.languageType="0";
            this.$i18n.locale='zh';
          }else{
            this.languageType="1"
            this.$store.state.languageType="1";
            this.$i18n.locale='en';
          }
          break;
        }
        document.title=this.$t("login.title");
  },
  data() {
    return {
      loginType: this.$util.defLanguage=='zh'?"1":'0',
      logining: false,
      languageType: this.$util.defLanguage=='zh'?"0":'1',
      toCountry: "86",
      ruleForm2: {
        username: "",
        password: ""
      },
      checked: false,
      note: {
        backgroundImage: "url(" + require("../assets/login.jpg") + ")",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover"
      }
    };
  },
  components: {
    country
  },
  methods: {
    onBeian(){
      window.location="https://beian.miit.gov.cn";
    },
    passwordForget(){
       this.$router.push({ path:"passwordForget"});
    },
    register(){
      this.$router.push({ path:"register"});
    },
    handleSubmit(event) {
      // this.$server.get().then(data => {
      //   alert(JSON.stringify(data));
      // });
      this.$refs.ruleForm2.validate(valid => {
        if (valid) {
          this.logining = true;
          var loginType = this.loginType;
          var username = this.ruleForm2.username;
          var password = this.ruleForm2.password;
          var toCountry = this.toCountry;
          var formData = new FormData();
          formData.append("account", username);
          formData.append("password", this.$md5(password+"2FB9680E").toLowerCase());
          if (loginType == 1) {
            formData.append("countryId", toCountry);
          } else {
          }
          formData.append("loginClient",0);
          this.$server.exam("/customer/security/login", formData).then(data => {
            if (data.code == 200) {
              this.logining = false;
              // sessionStorage.setItem("language", this.$i18n.locale);
              localStorage.setItem('language',this.$i18n.locale);
              this.$router.push({ path: "container" });
            } else {
              this.logining = false;
              this.$message({
                message: data.message,
                type: "warning"
              });
            }
          });
          // if (username === "admin" &&password === "123456") {
          //   this.logining = false;
          //   // sessionStorage.setItem("user", this.ruleForm2.username);
          //   this.$router.push({ path: "container" });
          // } else {
          //   this.logining = false;
          //   this.$alert("username or password wrong!", "info", {
          //     confirmButtonText: "ok"
          //   });
          // }
        } else {
          console.log("error submit!");
          return false;
        }
      });
    },
    languagesChange(event) {
      switch (this.languageType) {
        case "0":
          this.$i18n.locale = "zh";
          this.$store.state.languageType = "0";
          break;
        case "1":
          this.$i18n.locale = "en";
          this.$store.state.languageType = "1";
          break;
        default:
          if(this.$util.defLanguage=='zh'){
            this.$i18n.locale = "zh";
            this.$store.state.languageType = "0";
          }else{
            this.$i18n.locale = "en";
            this.$store.state.languageType = "1";
          }
          break;  
      }
      localStorage.setItem('language',this.$i18n.locale);
      document.title=this.$t("login.title");
      location.reload();
    },
    updateCountry(data) {
      //触发子组件城市选择-选择城市的事件
      this.toCountry = data; //改变了父组件的值
      // alert('toCountry:'+this.toCountry)
    }
  }
};
</script>

<style scoped>
.login-container {
  width: 100%;
  height: 100%;
}
.login-page {
  position: absolute;
  left: 50%;
  top: 15%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  -webkit-border-radius: 5px;
  border-radius: 5px;
  /*margin: 0 auto;*/
  width: 350px;
  padding: 15px 35px 15px;
  background: rgba(0, 0, 0, 0.6) none repeat scroll !important; /* rgba(0, 0, 0, 0.2) 前三个确定颜色，最后0.2确定透明度 */
  /*实现FireFox背景透明，文字不透明*/
  filter: Alpha(opacity=10);
  border: 1px solid rgba(0, 0, 0, 0.3);
  box-shadow: 0 0 25px #cac6c6;
}
/*清除浮动代码*/
.clearfloat:after{display:block;clear:both;content:"";visibility:hidden;height:0}
.clearfloat{zoom:1}

#beian:hover{
  color: #409EFF;
  cursor: pointer;
}

/* label.el-checkbox.rememberme {
  margin: 0px 0px 15px;
  text-align: left;
  color: white;
} */
 
</style>



// WEBPACK FOOTER //
// src/components/login.vue